import React from 'react';
import PropertyGridUtils from '../PropertyGridUtils';

import CodeEditor from './CodeEditor';

// import 'codemirror/lib/codemirror.css';
// import 'codemirror/theme/material.css';
// // import 'codemirror/theme/neat.css';
// import 'codemirror/mode/css/css';

export default class JsonEditor extends CodeEditor {
    mode = "json"
    render() {
        return super.render();
    }
}

PropertyGridUtils.register("json", (source, propertyGrid) => <JsonEditor source={source} propertyGrid={propertyGrid} />);